import IntlMessageFormat from 'intl-messageformat'

export default {
  registro: value =>
    new IntlMessageFormat(
      `{value, plural, =0 {0 registros} =1 {# registro} other {# registros}}`,
      'pt-BR'
    ).format({ value }),
  cliente: value =>
    new IntlMessageFormat(
      `{value, plural, =0 {0 clientes} =1 {# cliente} other {# clientes}}`,
      'pt-BR'
    ).format({ value }),
  atendimentos: value =>
    new IntlMessageFormat(
      `{value, plural, =0 {0 atencimentos} =1 {# atendimento} other {# atendimentos}}`,
      'pt-BR'
    ).format({ value })
}
